import './AccountSuspendedOverlay.scss';

import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import HttpService from '../../../services/HttpService';
import store from '../../../store';
import { AUTH_LOGOUT } from '../../../store/actions';

type Props = {
  isLogged: boolean;
  isSuspended: boolean;
};

function AccountSuspendedOverlay({ isLogged, isSuspended }: Props) {
  const { t } = useTranslation();

  if (!isLogged || !isSuspended) {
    return null;
  }

  const handleLogout = () => {
    HttpService.post('/auth/logout')
      .catch(() => null)
      .finally(() => {
        store.dispatch({ type: AUTH_LOGOUT });
        window.location.href = '/';
      });
  };

  return (
    <div className="account-suspended-overlay" role="dialog" aria-modal="true">
      <div className="account-suspended-overlay__panel">
        <div className="account-suspended-overlay__title">
          {t('account_suspended_title', 'Account suspended')}
        </div>
        <div className="account-suspended-overlay__text">
          {t(
            'account_suspended_message',
            'Your account is temporarily suspended. Please contact customer support.'
          )}
        </div>
        <button type="button" className="account-suspended-overlay__logout" onClick={handleLogout}>
          {t('account_suspended_logout', 'Log out')}
        </button>
      </div>
    </div>
  );
}

const mapState = (state: any) => ({
  isLogged: state.AuthReducer.isLogged,
  isSuspended: state.AuthReducer.isSuspended,
});

export default connect(mapState)(AccountSuspendedOverlay);
